/* eslint-disable no-unused-vars */
import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/navbar.styles'
import logo from './assets/images/logo.svg'
import menu from './assets/images/menu.svg'
import { useAppDispatch } from '../app/hooks/reduxHooks'
import { setDialogOpen } from '../app/pageIndexSlice'
import SmoothScroll from 'smooth-scroll'
import { HomePageConfig } from '../configuration'

const useStyles = makeStyles(styles)

function Navbar({ btnBackground, btnColor }) {
    const anchorScroll = new SmoothScroll('a[href*="#"]', {
        speedAsDuration: true,
        speed: 1000
    })
    const props = {
        btnColor,
        btnBackground
    }
    const classes = useStyles(props)
    const dispatch = useAppDispatch()
    const handleClick = () => {
        dispatch(setDialogOpen(true))
    }
    return (
        <div className={classes.root}>
            <a href={HomePageConfig.website} target='_blank' className={classes.a} ><img alt='logo' src={logo} className={classes.logo} /></a>
            <span className={classes.span} >
                <a href={HomePageConfig.contactbtnslug} className={classes.button} > {HomePageConfig.contactbtn} </a>
                <img onClick={handleClick} src={menu} alt='menu' className={classes.menu} />
            </span>
        </div>
    )
}

export default memo(Navbar)
